import gql from 'graphql-tag';

const VENDOR_BATCH_LIST_ADD = gql`
  mutation Mutation($batch: String!) {
    addMfgVendorBatch(batch: $batch) {
      code
    }
  }
`;

export default VENDOR_BATCH_LIST_ADD;
